import script from "./AddTagForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTagForm.vue?vue&type=script&setup=true&lang=js"

import "./AddTagForm.vue?vue&type=style&index=0&id=1d5bda3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d5bda3a"]])

export default __exports__